import { useQuery } from '@tanstack/react-query'
import { PlacesApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { placeGroupQueryKeys } from './queryKeys'

export const useQueryPlaceGroups = () => {
  return useQuery({
    queryKey: placeGroupQueryKeys.list,
    queryFn: async () => {
      return await baseClient
        .getApi(PlacesApi)
        .getPlaceGroups()
        .catch(handleHTTPError)
    },
  })
}
